// extracted by mini-css-extract-plugin
module.exports = {"image":"about-rj-module--image--1R5EX"};